export default {

  namespaced: true,

  state: () => ({

    transactions: [],

  }),

  mutations: {
    setTransactions(state, transactions) {
      state.transactions = transactions
    }

  },

  actions: {
    async getTransactions({ dispatch, commit }, params) {

      await axios.get("/erp/account/accounttransaction", { params : params })
        .then(response => {

          commit('setTransactions', response.data.accountTransactions)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        })
    },

    async storeAccountTransaction({ dispatch, commit }, params) {

      await axios.post("/erp/account/accounttransaction", params)
        .then(response => {


        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        })

    },

    async destroyAccountTransaction({ dispatch, commit }, id) {


      await axios.delete("/erp/account/accounttransaction/" + id)
        .then(response => {

          this.$store.commit("showAlert", {
            message: "Transação Cancelada!",
            type: "error",
          });

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        })

    },

    async export({ dispatch }, params) {

      const data = await axios({
        url: "erp/account/export",
        method: "GET",
        responseType: "blob",
      }, params);

      return data;
    },
    async getDrawerTransactions({ dispatch, commit }, params) {

      const data = await axios.get("/erp/account/drawer-report", { params : params })
    
      return data
    },

  }
}
